import { render, staticRenderFns } from "./FeedbackStatus.vue?vue&type=template&id=718855ac&scoped=true&"
import script from "./FeedbackStatus.vue?vue&type=script&lang=js&"
export * from "./FeedbackStatus.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackStatus.vue?vue&type=style&index=0&id=718855ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718855ac",
  null
  
)

export default component.exports